import mixpanel from 'mixpanel-browser'
import { isAnalyticsEnabled } from '../../../modules/main/app/common/cookies-utils'
import { MIXPANEL_ENVIRONMENT_PLACEHOLDER } from './const'

const MIXPANEL_TOKEN_DEV = '756fde7ce2c4a5021cc58903604b3eb7'
const MIXPANEL_TOKEN_PROD = '494866c9c7503ca2d52ae575e4af1ebd'
const MIXPANEL_ENVIRONMENT = 'production'

const isRunningLocally = MIXPANEL_ENVIRONMENT === MIXPANEL_ENVIRONMENT_PLACEHOLDER

const ENVIRONMENT = Object.freeze({
    DEVELOPMENT: 'development',
    STAGE: 'stage',
    PRODUCTION: 'production'
})

/**
 * Calls initialisation script of Mixpanel and registers the environment,
 * so that the value will be added to each tracked event during the session.
 */
const initializeMixpanel = () => {
    try {
        const token = MIXPANEL_ENVIRONMENT === ENVIRONMENT.PRODUCTION ? MIXPANEL_TOKEN_PROD : MIXPANEL_TOKEN_DEV

        mixpanel.init(token, {
            api_host: 'https://api-eu.mixpanel.com',
            debug: true,
            ignore_dnt: true,
            opt_out_persistence_by_default: true,
            persistence: 'localStorage',
            store_google: false
        })

        mixpanel.clear_opt_in_out_tracking()
        mixpanel.register({ environment: MIXPANEL_ENVIRONMENT, productName: 'Device Activation Service UI' })
        console.warn('Mixpanel initialization successfully finished.')
    } catch (error) {
        console.warn('Mixpanel initialization failed', error)
    }
}

/**
 * Checking cookies consent settings and initializing analytics if user allowed
 * in consent settings
 */
export const checkConsentAndInitializeAnalyticsIfAllowed = () => {
    if (isRunningLocally) {
        console.warn('Local run detected. Skipping Mixpanel initialization')
        return
    }

    const analyticsEnabled = isAnalyticsEnabled()

    if (analyticsEnabled) {
        console.warn(
            `Analytics consent accepted. Mixpanel initialization started. Mixpanel configuration: ${MIXPANEL_ENVIRONMENT}`
        )
        initializeMixpanel()
    } else {
        console.warn('Analytics consent declined. Mixpanel disabled.')
        if (mixpanel.config) {
            try {
                mixpanel.disable()
            } catch (error) {
                console.error('Error while resetting mixpanel')
            }
        }
    }
}
